module.exports = __webpack_public_path__ + "static/img/hero_pizza.9ef279d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hero_pizza.png
// module id = HQqe
// module chunks = 0